const config = {
  routes: {
    label: 'Privacy Notice',
    prefix: '/privacynotice',
  },
}

export default config
